export default {
    path : "warehouse-item-sea",
    name : "warehouse-item-sea",
    meta : {
        title : "项目公海"
    },
    component: () => import('@/pages/warehouse/sea/Index'),
    redirect: {
        name : "warehouse-item-sea-whole"
    },
    children: [
        {
            path: 'all',
            name: 'warehouse-item-sea-whole',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'warehouse-item-sea-recent',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'warehouse-item-sea-atme',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'warehouse-item-sea-meat',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'warehouse-item-sea-reply',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'warehouse-item-sea-search',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/warehouse/seaitem/index.js